/*Tps-report*/
if (window.location.pathname.includes("reports/available-properties")) {
  const propertyTypes = {
    single: "Single Family Home",
    townhouse: "Townhouse",
    apartment: "Apartment",
    condo: "Condo"
  };

  const amenitiesLabels = {
    appliances: {
      aircon: "A/C",
      dishwasher: "Dishwasher",
      microwave: "Microwave",
      refrigerator: "Refrigerator",
      stove: "Stove"
    },
    amenities: {
      fenced_yard: "Fenced Yard",
      ranch_style: "Ranch Style",
      handicap_accessible: "Handicap Accessible",
      walk_in_shower: "Walk-in Shower",
      balcony: "Balcony / Deck",
      finished_basement: "Finished Basement",
      lawn_care: "Lawn Care",
      snow_removal: "Snow Removal",
      swimming_pool: "Swimming Pool",
      utilities: "Utilities Included"
    },
    laundry: {
      none: "None",
      in_unit: "In unit",
      shared: "Shared / In-building"
    },
    flooring: {
      carpet: "Carpet",
      hardwood: "Hardwood",
      other: "Other"
    },
    windows: {
      blinds: "Blinds",
      drapes: "Drapes",
      shades: "Shades",
      none: "None"
    }
  };

  $.each($(".data-table"), function() {
    $(this).data("options", window.app_data.datatableOptions);
  });

  $("[name='properties_search']").on("keyup", function() {
    let val = $(this).val();
    $.each($(".data-table"), function() {
      $(this)
        .DataTable()
        .search(val)
        .draw();
    });
  });

  $(".data-table").on("click", ".btn-apply", function(e) {
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);
    const data = table
      .DataTable()
      .row(tr)
      .data();

    openApplyModal(data.id, table);
  });

  $(".data-table").on("click", ".btn-delete", function(e) {
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);
    const data = table
      .DataTable()
      .row(tr)
      .data();

    Swal.fire({
      title: "Delete Property",
      html: "Are you sure you want to delete this property?",
      icon: undefined,
      showCancelButton: true,
      showDenyButton: true,
      showConfirmButton: false,
      denyButtonText: "Delete",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      preDeny: async () => await deleteProperty(data.id, table, tr)
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "Property is deleted.", "success");
      }
    });
  });

  $(".data-table").on("click", ".btn-view", async function(e) {
    const table = $(this).closest(".data-table");
    const tr = $(this)
      .closest("tr")
      .get(0);
    const data = table
      .DataTable()
      .row(tr)
      .data();

    Swal.fire({
      title: "Property Details",
      allowOutsideClick: false,
      heightAuto: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const logs = await getPropertyLogs(data.id);

    Swal.fire({
      title: "Property Details",
      html: getPropertyDetails(data),
      footer: getPropertyLogHtml(logs),
      icon: undefined,
      showCancelButton: true,
      confirmButtonText: "Apply",
      showConfirmButton: !data.applied,
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      width: 1024,
      preConfirm: () => openApplyModal(data.id, table)
    });
  });

  function getPropertyLogs(id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `/api/qualifying_property/${id}/logs`,
        method: "GET",
        dataType: "json",
        success: response => resolve(response),
        error: response => reject(response)
      });
    });
  }

  function getPropertyLogHtml(logs) {
    return `<div id="tps-placement-changelog" class="card mb-4 w-100">
      <div class="card-header d-flex" id="tps-placement-changelog-header-active">
        <div class="col p-0 d-flex align-items-center">
          <h4 class="m-0">Property Log</h4>
        </div>
        <div class="col text-right">
          <button class="btn btn-link py-0 collapsed" data-toggle="collapse" data-target="#tps-placement-changelog-body-active" aria-expanded="false" aria-controls="tps-placement-changelog-body-active"></button>
        </div>
      </div>

      <div id="tps-placement-changelog-body-active" class="collapse" aria-labelledby="tps-placement-changelog-header-active" data-parent="#tps-placement-changelog">
        <div class="card-body">
        ${
          logs && logs.length
            ? `<div class="row" v-if="placement.log && placement.log.length > 0">
                <div class="col-5 col-md-4"><strong>Timestamp</strong></div>
                <div class="col-7 col-md-8"><strong>Description</strong></div>
              </div>

              ${logs
                .map(
                  log => `<div class="row">
                  <div class="col-5 col-md-4">
                    ${moment(log.created_at)
                      .local()
                      .format("MM/DD/YYYY hh:mm:ss A")}
                  </div>
                  <div class="col-7 col-md-8">${log.description}</div>
                </div>`
                )
                .join("")}`
            : '<p class="mt-3">No property logs available</p>'
        }
        </div>
      </div>

      <div class="card-footer bg-secondary"></div>
    </div>`;
  }

  function openApplyModal(id, table) {
    Swal.fire({
      title: "",
      html: `<div id="applyProperty" class="form-group mt-5 mb-3">
          <label class="form-control-wrap">Apply Property to:</label>
          <v-select class="form-control" name="apply_placement_id" :options="options"></v-select>
        </div>`,
      icon: undefined,
      showCancelButton: true,
      confirmButtonText: "Apply",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      heightAuto: false,
      preConfirm: async () => await applyProperty(id, table),
      onRender: () => {
        new Vue({
          el: `#applyProperty`,
          data: { options: app_options.placements }
        });
      }
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire("Applied", "Property is applied.", "success");
      }
    });
  }

  async function applyProperty(qualifying_property_id, table) {
    try {
      const placement_id = $('[name="apply_placement_id"]').val();

      if (!placement_id) return Swal.showValidationMessage(`Please select placement.`);

      const result = await new Promise((resolve, reject) => {
        $.ajax({
          url: `/api/qualifying_property/update`,
          method: "POST",
          data: { qualifying_property_id, placement_id, action: "apply" },
          dataType: "json",
          success: response => resolve(response),
          error: response => reject(response)
        });
      });

      if (!$.fn.dataTable.isDataTable(table)) {
        console.error("Incorrect datatable component!");
        return;
      }

      table.DataTable().destroy();
      table.empty();
      let html = "<thead><tr>";
      let header = window.app_data.table_keys;
      for (let i in header) {
        html += `<td data-column="${i}" class="col-${i}">${header[i]}</td>`;
      }
      html += "</tr></thead>";
      table.html(html);
      table.data("options", window.app_data.datatableOptions);
      window.dataTableInstance(table);
      $("[name='properties_search']").trigger("keyup");
      return result;
    } catch (e) {
      Swal.showValidationMessage(`There is something wrong!`);
      return false;
    }
  }

  async function deleteProperty(qualifying_property_id, table, tr) {
    try {
      const result = await new Promise((resolve, reject) => {
        $.ajax({
          url: `/api/qualifying_property/update`,
          method: "POST",
          data: { qualifying_property_id, action: "delete" },
          dataType: "json",
          success: response => resolve(response),
          error: response => reject(response)
        });
      });

      table
        .DataTable()
        .row(tr)
        .remove()
        .draw();
      return result;
    } catch (e) {
      Swal.showValidationMessage(`There is something wrong!`);
      return false;
    }
  }

  function getPropertyValue(data, propertyPath) {
    const pathParts = propertyPath.split(".");

    let result = data;
    for (let part of pathParts) {
      if (result && result[part] !== undefined) {
        result = result[part];
      } else {
        return [];
      }
    }

    return result || [];
  }

  function getPropertyDetails(data) {
    const landlord = data.landlord ? JSON.parse(data.landlord) : {};
    const details = data.details ? JSON.parse(data.details) : {};
    const amenities = data.amenities ? JSON.parse(data.amenities) : {};

    return `<div class="row text-left">
      <div class="col col-md-6 mb-4">
          <h3>Landlord Information</h3>
          <p class="mb-0"><strong>First Name:</strong> ${landlord.first_name || "-"}</p>
          <p class="mb-0"><strong>Last Name:</strong> ${landlord.last_name || "-"}</p>
          <p class="mb-0"><strong>Management Company:</strong> ${landlord.company || "-"}</p>
          <p class="mb-0"><strong>Phone:</strong> ${landlord.phone || "-"}</p>
          <p class="mb-0"><strong>Cell Phone:</strong> ${landlord.cellphone || "-"}</p>
          <p class="mb-0"><strong>Email:</strong> ${landlord.email || "-"}</p>
          <p class="mb-0"><strong>Billing Address:</strong> ${landlord.address || "-"}</p>
      </div>
      <div class="col col-md-6 mb-4">
          <h3>Property Information</h3>
          <p class="mb-0"><strong>Property Type:</strong> ${propertyTypes[data.type] || "-"}</p>
          <p class="mb-0"><strong>Property Address:</strong> ${data.address || "-"}</p>
          <p class="mb-0"><strong>Property City:</strong> ${data.city || "-"}</p>
          <p class="mb-0"><strong>Property State:</strong> ${data.state || "-"}</p>
          <p class="mb-0"><strong>Property Zip:</strong> ${data.zip || "-"}</p>
          <p class="mb-0"><strong>Unit Number:</strong> ${data.unit_number || "-"}</p>
          <p class="mb-0"><strong>Complex:</strong> ${data.complex || "-"}</p>
      </div>

      <div class="col col-md-6 mb-4">
          <h3>Details and Description</h3>
          <p class="mb-0"><strong>Monthly Rent Price:</strong> $${window.formatMoney(details.monthly_rent) || "0.00"}</p>
          <p class="mb-0"><strong>Minimum Lease Duration:</strong> ${details.lease_duration || "-"}</p>
          <p class="mb-0"><strong>Refundable Security Deposit Amount:</strong> $${window.formatMoney(details.security_deposit) || "0.00"}</p>
          <p class="mb-0"><strong>Date Available:</strong> ${details.date_available ? moment(details.date_available).format("MM/DD/YYYY") : "-"}</p>
          <p class="mb-0"><strong>Bedrooms:</strong> ${details.bedrooms || "0"}</p>
          <p class="mb-0"><strong>Bathrooms:</strong> ${details.baths || "0"}</p>
          <p class="mb-0"><strong>Square Footage:</strong> ${details.sqft || "0"}</p>
          <p class="mb-0"><strong>Parking:</strong> ${details.parking || "0"}</p>
          <p class="mb-0"><strong>Property Website:</strong> <a href="${details.website}" target="_blank">${details.website || ""}</a></p>
          <p class="mb-0"><strong>School District:</strong> ${details.school_district || "-"}</p>
      </div>
      <div class="col col-md-6 mb-4">
          <h3>Amenities and Specifications</h3>
          <p class="mb-0"><strong>Pets Allowed:</strong> ${amenities.pets}</p>
          <p class="mb-0"><strong>Furnished:</strong> ${amenities.furnished}</p>
          <p class="mb-0"><strong>Appliances:</strong></p>
          <ul class="mb-0">
              ${getPropertyValue(amenities, "appliances")
                .map(amenity => `<li>${amenitiesLabels.appliances[amenity] || "-"}</li>`)
                .join("")}
          </ul>
          <p class="mb-0"><strong>Amenities:</strong></p>
          <ul class="mb-0">
              ${getPropertyValue(amenities, "amenities")
                .map(amenity => `<li>${amenitiesLabels.amenities[amenity] || "-"}</li>`)
                .join("")}
          </ul>
          <p class="mb-0"><strong>Flooring:</strong> ${(amenities && amenitiesLabels.laundry[amenities.laundry]) || "-"}</p>
          <p class="mb-0"><strong>Flooring:</strong></p>
          <ul class="mb-0">
              ${getPropertyValue(amenities, "flooring")
                .map(amenity => `<li>${amenitiesLabels.flooring[amenity] || "-"}</li>`)
                .join("")}
          </ul>
          <p class="mb-0"><strong>Windows:</strong></p>
          <ul class="mb-0">
              ${getPropertyValue(amenities, "windows")
                .map(amenity => `<li>${amenitiesLabels.windows[amenity] || "-"}</li>`)
                .join("")}
          </ul>
      </div>
  </div>`;
  }

  //** FROM TPS WEBSITE */
  window._uspsValidAddress = false;
  const markers = [];
  let map = null;

  $(function() {
    if (typeof window.maps_loaded !== "undefined") {
      loadMap();
    } else {
      window.initMap = loadMap;
    }

    $(".addrValidator").click(() => geocodeAddress());
    $("#property_address").on("change", () => {
      window._uspsValidAddress = false;

      $("#property_address_address").val("");
      $("#property_address_city").val("");
      $("#property_address_state").val("");
      $("#property_address_state_id").val("");
      $("#property_address_zip").val("");
      $("#property_address_latitude").val("");
      $("#property_address_longitude").val("");
    });
  });

  function removeMarkers() {
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap();
    }
  }

  function loadMap() {
    const input = document.querySelector("#property_address");
    const propertyAddress = new google.maps.LatLng(31.789496842, -94.173665972);

    map = new google.maps.Map(document.querySelector(".property-map"), {
      zoom: 3,
      center: propertyAddress
    });

    const options = { types: ["address"] };
    let autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.setFields(["address_components", "geometry"]);
    autocomplete.addListener("place_changed", function() {
      const place = autocomplete.getPlace();
      setAddressComponents(place, map);
    });
  }

  function geocodeAddress(proceedSubmit = false, skipAlert = false) {
    window._uspsValidAddress = false;

    const geocoder = new google.maps.Geocoder();
    const address = document.getElementById("property_address").value;

    geocoder
      .geocode({ address: address })
      .then(({ results }) => {
        setAddressComponents(results[0], map, skipAlert);
        if (window._uspsValidAddress && proceedSubmit) $("#property-form").submit();
      })
      .catch(e => {
        window._uspsValidAddress = false;

        return skipAlert
          ? false
          : Swal.fire({
              icon: "error",
              title: "Address Validation",
              html: "Please make sure your address is a valid property in US.",
              heightAuto: false,
              confirmButtonText: "Try Again"
            });
      });
  }

  function setAddressComponents(place, map, skipAlert = false) {
    window._uspsValidAddress = false;

    const componentForm = {
      subpremise: { name: "short_name", value: "" },
      street_number: { name: "short_name", value: "" },
      route: { name: "short_name", value: "" },
      locality: { name: "long_name", value: "" },
      neighborhood: { name: "long_name", value: "" },
      administrative_area_level_1: { name: "long_name", value: "" },
      country: { name: "long_name", value: "" },
      postal_code: { name: "short_name", value: "" }
    };

    if (!place || !place.geometry) return;

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentForm[addressType]) {
        const val = place.address_components[i][componentForm[addressType]["name"]];
        componentForm[addressType]["value"] = val;
      }
    }

    const state = window.app_options.states.find(option => option.text == componentForm["administrative_area_level_1"]["value"]);

    if (!state) {
      return skipAlert
        ? false
        : Swal.fire({
            icon: "error",
            title: "Address Validation",
            html: "Please make sure your address is a valid property in US.",
            heightAuto: false,
            confirmButtonText: "Try Again"
          });
    }

    const location = place.geometry.location;
    const address = {
      unit: componentForm["subpremise"]["value"],
      address: componentForm["street_number"]["value"] + " " + componentForm["route"]["value"],
      city: componentForm["locality"]["value"] || componentForm["neighborhood"]["value"],
      state: state.text,
      state_id: state.id,
      zip: componentForm["postal_code"]["value"],
      latitude: location.lat(),
      longitude: location.lng()
    };

    let formatted_address = address.address;
    if (address.unit) {
      formatted_address += /^\d/.test(address.unit) ? ` #${address.unit}` : ` ${address.unit}`;
    }
    formatted_address += `, ${address.city}, ${address.state} ${address.zip}`;

    $("#property_address").val(formatted_address);
    $("#property_address_address").val(address.address);
    $("#property_address_city").val(address.city);
    $("#property_address_state").val(address.state);
    $("#property_address_state_id").val(address.state_id);
    $("#property_address_zip").val(address.zip);
    $("#property_address_latitude").val(address.latitude);
    $("#property_address_longitude").val(address.longitude);

    if (address.unit) {
      $("#property_unit_number").val(address.unit);
    }

    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(location);
      map.setZoom(17);
    }

    removeMarkers();

    const marker = new google.maps.Marker({
      position: location,
      map: map
    });
    marker.setPosition(location);
    markers.push(marker);

    window._uspsValidAddress = true;

    if (skipAlert) return;

    Swal.fire({
      title: "Address Validation",
      html: "Address validated successfully.",
      icon: "success",
      confirmButtonText: "Okay"
    });
  }
  //** FROM TPS WEBSITE */
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/available-properties.js